export default __webpack_public_path__ + "scene2_1_bgd43727.png";